import { useEffect, useState, type RefObject } from 'react'
import ReactDOM from 'react-dom'
import { ASSETS } from '../assets'

export const OverlayButton = ({
  targetRef,
  onClick,
  label,
}: {
  targetRef: RefObject<HTMLButtonElement | null>
  onClick: () => void
  label: string
}) => {
  const [pos, setPos] = useState<{
    top: number
    left: number
    width: number
    height: number
  } | null>(null)

  useEffect(() => {
    if (targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect()
      setPos({
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
      })
    }
  }, [targetRef])

  if (!pos) return null

  return ReactDOM.createPortal(
    <button
      onClick={onClick}
      style={{
        position: 'fixed',
        top: pos.top,
        left: pos.left,
        width: pos.width,
        height: pos.height,
        zIndex: 50, // definitely above canvas
      }}
      className="hover:bg-blue-tint-5 hover:text-blue active:bg-blue-tint-5 active:text-blue bg-blue-tint-3 flex items-center justify-between gap-40 px-6 py-3 text-left text-[20px] leading-[27px] font-light hover:cursor-pointer"
    >
      <span>{label}</span>
      <img src={ASSETS.iconArrowRight} width={24} height={15} />
    </button>,
    document.body
  )
}
